import { createContext } from "react";

// export const SidebarContext = createContext();
export const SidebarContext = createContext({
  toggleSidebar: false,
  setToggleSidebar: () => {},
  sidebarCollapsed: true,
  setSidebarCollapsed: () => {},
});
